import gql from 'graphql-tag'
import {
    RequestEventActivationMutation as ActivationMutation,
    RequestEventActivationMutationVariables as ActivationMutationVars,
    UpdateEventInput,
    UpdateEventMutation,
    UpdateEventMutationVariables
} from 'generated/graphql'
import graphql from 'utils/graphql'

// Update Event
const updateEventMutation = gql`
    mutation updateEvent($event: EventID!, $data: UpdateEventInput!) {
        updateEvent(event: $event, data: $data) {
            id
            virtualEventLogo
            backgroundImage
        }
    }
`

export const updateEvent = (event: string|number, data: UpdateEventInput) => {
    const query = graphql.createQuery<UpdateEventMutation, UpdateEventMutationVariables>(updateEventMutation)
    return query({ event, data })
}

// Activate Event
const activateEventMutation = gql`
    mutation requestEventActivation($event: EventID!) {
        requestEventActivation(eventId: $event) {
            id
        }
    }
`

export const activateEvent = (event: string|number) => {
    const query = graphql.createQuery<ActivationMutation, ActivationMutationVars>(activateEventMutation)
    return query({ event })
}
